"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogoutRedirectUri = exports.completeUserLogout = void 0;
var _validation = require("./utils/validation.js");
var _ValidationError = _interopRequireDefault(require("./error/ValidationError.js"));
var _errorCode = require("./error/error-code.js");
var _LogoutError = _interopRequireDefault(require("./error/LogoutError.js"));
var _authzCookie = require("./authz-cookie.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getLogoutRedirectUri = function getLogoutRedirectUri(postLogoutRedirectUri) {
  return function (idToken) {
    return function (clientId) {
      return function (logoutUri) {
        if (!(0, _validation.isStringWithLength)(logoutUri) || !(0, _validation.isValidUri)(logoutUri)) {
          throw new _ValidationError["default"](_errorCode.VALIDATION, 'No logoutUri set');
        }
        if (!(0, _validation.isStringWithLength)(postLogoutRedirectUri) || !(0, _validation.isValidUri)(postLogoutRedirectUri)) {
          throw new _ValidationError["default"](_errorCode.VALIDATION, 'No postLogoutRedirectUri set');
        }
        if (!(0, _validation.isStringWithLength)(idToken)) {
          throw new _ValidationError["default"](_errorCode.VALIDATION, 'No id_token_hint set');
        }
        return "".concat(logoutUri, "?id_token_hint=").concat(idToken, "&client_id=").concat(clientId, "&post_logout_redirect_uri=").concat(encodeURIComponent(postLogoutRedirectUri));
      };
    };
  };
};
exports.getLogoutRedirectUri = getLogoutRedirectUri;
var completeUserLogout = function completeUserLogout(loc) {
  return function (cacheName) {
    var urlParams = new URLSearchParams(loc.search);
    if (urlParams.has('error')) {
      var errorDescription = urlParams.has('error_description') ? urlParams.get('error_description') : '';
      var errorCode = urlParams.get('error');
      throw new _LogoutError["default"](_errorCode.LOGOUT, errorCode, errorDescription);
    }
    (0, _authzCookie.rmAuthzCookie)(cacheName);
    // TODO: Verify against EDS Login that the redirect was initiated by us
    var stateB64 = urlParams.get('state');
    var stateJson = atob(stateB64);
    var state = JSON.parse(stateJson);
    if ("postLogoutRedirectUri" in state) {
      return state.postLogoutRedirectUri;
    } else {
      throw new _ValidationError["default"](_errorCode.VALIDATION, "No redirect uri found in state");
    }
  };
};
exports.completeUserLogout = completeUserLogout;